var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { http } from "../client";
export var updateTimetable = function (_a) {
    var id = _a.id, title = _a.title, entries = _a.entries;
    var data = {
        id: id,
        title: title,
        entries: entries.map(function (entry) {
            var _a;
            var base = {
                id: entry.id,
                title: (_a = entry.title) !== null && _a !== void 0 ? _a : "",
                days_enabled: entry.daysEnabled,
                time_start: entry.timeStart,
                time_end: entry.timeEnd,
                play_order: entry.playOrder,
                strict_order: entry.strictOrder,
                interrupt_playing: entry.interruptPlaying,
            };
            return entry.trackId
                ? __assign(__assign({}, base), { track_id: entry.trackId, track_repeat_interval_minutes: entry.trackRepeatIntervalMinutes }) : __assign(__assign({}, base), { playlist_id: entry.playlistId, n_tracks: entry.nTracks });
        }),
    };
    return http.api.put("timetables/" + id, data);
};
